// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chartApp-element{height:300px;background:#ffffff;padding:20px}.chartContent-element{height:300px;background:#ffffff;padding:20px}.header{background:#ffffff;min-height:30px;margin-bottom:10px}.mt-3{margin-top:30px}.add-agent-page{margin-top:30px;width:100%}.add-agent-page>div.ant-collapse{max-width:500px;margin:auto}\n", ""]);
// Exports
module.exports = exports;
